
export default {
    name: 'manage-view',
    components: {},
    props: {
        operation_tresorerie: {
            type: Object,
            default: () => {}
        },
        view_toggler: {
            type: Number,
            default: 0
        },
        solde_banque: {
            type: Object,
            default: () => {}
        }
    },

    watch: {
        view_toggler() {
            this.filename = ''
            this.is_loading = true
            this.file_is_empty = false

            if (this.operation_tresorerie.preuve == '' || this.operation_tresorerie.preuve == null) {
                this.file_is_empty = true
                this.is_loading = false
                return;
            }

            this.can_preview = this.checkIfCanPreview()

            this.asset_url = this.assets_path + '/files/preuves/'
            this.filename = this.asset_url+this.operation_tresorerie.preuve


            setTimeout(() => {
                this.is_loading = false
            }, 1000);
        }
    },

    data() {
        return {
            asset_url: '',
            filename: '',
            is_loading: true,
            file_is_empty: false,
            can_preview: true
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        checkIfCanPreview() {
            const filename = this.operation_tresorerie.preuve
            let can_view = false

            if (filename != '') {
                if (
                    filename.includes('pdf') || filename.includes('png') || 
                    filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                    filename.includes('jpg') || filename.includes('JPG') 
                ) {
                    can_view = true
                }
            }
            return can_view
        }
    }
}


